module.exports = __webpack_public_path__ + "img/03-1.3fb92837.png";